import { TransportEventsTable } from "@/components/stock/transport-events-table";
import { useSuborderTransportEvents } from "@/hooks/use-suborder-transport-events";
import type { SuborderPanelBaseProps } from "../../shared";

/**
 * The round's chain of custody: every carrier it shipped and every hand that moved one.
 *
 * The picking round is the widest scope this history can have, and that is a property of the
 * model rather than a choice here. A `loadCarrierUnits` row is "box 3 of 18 on this round" —
 * nothing reuses or returns one, because the physical carriers come back as a counted balance on a
 * Leergut round and there are far too many of them to label individually. So a carrier's whole
 * recorded life is the shipment it was labelled for, and this is that life.
 */
export function SuborderTransport({ orderId, suborderId }: SuborderPanelBaseProps) {
	/** Query */
	const { events, isLoading, refetch, queryKey } = useSuborderTransportEvents(orderId, suborderId);

	/** Render */
	return (
		<TransportEventsTable
			events={events}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			persistenceKey="suborder-transport-table"
		/>
	);
}
